export function getEntry(key: string): string | undefined {
  try {
    if (typeof window === 'undefined' || !localStorage || !key) {
      return;
    }

    const localStorageValue: string | null = localStorage.getItem(key);
    if (!localStorageValue) {
      return;
    }

    return localStorageValue;
  } catch (error) {
    console.error('getEntry - Local storage error', error);
    return;
  }
}

export function setEntry(key: string, value: string): void {
  try {
    if (typeof window === 'undefined' || !localStorage || !key) {
      return;
    }

    localStorage.setItem(key, value);
  } catch (error) {
    console.error('setEntry - Local storage error', error);
  }
}

export function removeEntry(key: string): void {
  try {
    if (typeof window === 'undefined' || !localStorage || !key) {
      return;
    }

    localStorage.removeItem(key);
  } catch (error) {
    console.error('removeEntry - Local storage error', error);
  }
}

export function isValidEntry(key: string): boolean {
  try {
    if (typeof window === 'undefined' || !localStorage || !key) {
      return false;
    }

    const localStorageValue: string | null = localStorage.getItem(key);
    if (!localStorageValue) {
      return false;
    }

    return true;
  } catch (error) {
    console.error('isValidEntry - Local storage error', error);
    return false;
  }
}

export function clearEntries(): void {
  try {
    if (typeof window === 'undefined' || !localStorage) {
      return;
    }

    localStorage.clear();
  } catch (error) {
    console.error('clearEntries - Local storage error', error);
  }
}

export const localStorageService = {
  getEntry,
  setEntry,
  removeEntry,
  isValidEntry,
  clearEntries,
};
